
import { mapActions, mapGetters } from "vuex";
import UiInputWrapper from "~/components/UI/UiInputWrapper";
import UiInput from "~/components/UI/UiInput";
import UiButton from "~/components/UI/UiButton";

export default {
  name: "LoginForm",
  components: {
    UiButton,
    UiInput,
    UiInputWrapper,
  },
  data() {
    return {
      showForgot: false,
      loadingAuth: false,
      loadingForgot: false,
      authForm: {
        email: "",
        password: "",
      },
      forgotForm: {
        email: "",
      },
      passwordVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      cartId: "getCartId",
    }),
    formText() {
      if (this.showForgot) {
        return {
          title: this.$t("forgotTitle"),
          description: this.$t("forgotDesc"),
        };
      } else {
        return {
          title: this.$t("loginTitle"),
          description: this.$t("loginDesc"),
        };
      }
    },
  },
  methods: {
    ...mapActions({
      setUserInfo: "auth/setUserInfo",
      getCart: "getCart",
      getWishList: "getWishList",
      getCompareList: "getCompareList",
    }),
    switchForm(status) {
      this.showForgot = status;
      this.$nextTick(() => {
        if (status) {
          this.$refs.forgotForm?.reset();
        } else {
          this.$refs.authForm?.reset();
        }
      });
    },
    async onSubmit() {
      if (this.loadingAuth) return;
      this.loadingAuth = true;
      const params = {
        ...this.authForm,
      };
      if (this.cartId) {
        params.cart_unique_id = this.cartId;
      }
      try {
        const response = await this.$api.auth.signIn(params);
        const userData = response.data.data;
        delete userData.role;
        delete userData.action;
        await this.setUserInfo(userData);
        // await this.getCart();
        await Promise.all([
          this.getCart(),
          this.getWishList(),
          this.getCompareList(),
        ]);
        await this.$router.replace(
          this.localePath(this.$route.query.redirect || "/")
        );
      } catch (error) {
        if (
          error.response.data.errors[0].property &&
          Object.hasOwn(this.authForm, error.response.data.errors[0].property)
        ) {
          this.$refs.authForm.setErrors({
            [error.response.data.errors[0].property]:
              error.response.data.errors[0].message,
          });
        }
      } finally {
        this.loadingAuth = false;
      }
    },
    async onSubmitForgot() {
      if (this.loadingForgot) return;
      this.loadingForgot = true;
      try {
        await this.$api.user.recoveryPasswordRequest(this.forgotForm);
        this.$alert({
          title: `${this.$t("success")}!`,
          text: `${this.$t("recoverPasswordMessage")}.`,
        });
      } catch (error) {
        if (
          error?.response?.data?.errors?.[0]?.property &&
          Object.hasOwn(this.authForm, error.response.data.errors[0].property)
        ) {
          this.$refs.forgotForm.setErrors({
            [error.response.data.errors[0].property]:
              error.response.data.errors[0].message,
          });
        }
      } finally {
        this.loadingForgot = false;
      }
    },
  },
};
